import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import {
  AdherentDetailResponse,
  ComptesAdherentResponse,
  SituationDossierResponse,
  SyntheseComptesResponse,
} from '../../interfaces/adherent.interface';
import { HistoriqueResponse } from '../fiche-credit/models';
import { AdherentService } from '../../services/adherent.service';


export const ficheClientResolver: ResolveFn<AdherentDetailResponse> = (route: ActivatedRouteSnapshot) => {
  const codeClient = route.paramMap.get('id') ?? '';
  return inject(AdherentService).getAdherent(codeClient);
};

/** Actions du client : alimentent l'onglet « Historique des actions » et l'aperçu. */
export const historiqueClientResolver: ResolveFn<HistoriqueResponse> = (route: ActivatedRouteSnapshot) => {
  const codeClient = route.paramMap.get('id') ?? '';
  return inject(AdherentService).getActionHistorique(codeClient);
};

/** Comptes du client : alimentent l'aperçu (onglets de compte + synthèse). */
export const comptesClientResolver: ResolveFn<ComptesAdherentResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const codeClient = route.paramMap.get('id') ?? '';
  return inject(AdherentService).getComptesClient(codeClient);
};

/** Situation des comptes (numéro, intitulé, solde) : alimente l'onglet « Synthèse ». */
export const syntheseComptesClientResolver: ResolveFn<SyntheseComptesResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const codeClient = route.paramMap.get('id') ?? '';
  return inject(AdherentService).getSyntheseComptes(codeClient);
};

export const situationDossiersResolver: ResolveFn<SituationDossierResponse> = (
  route: ActivatedRouteSnapshot
) => {
  const codeClient = route.paramMap.get('id') ?? '';
  return inject(AdherentService).getSituationDossier(codeClient);
}
